export function getUid() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`
}

// 解析时间区间 "mm:ss-mm:ss" 为秒
export function parseTimeRange(range) {
  if (!range || typeof range !== 'string' || !range.includes('-')) return null
  const [startStr, endStr] = range.split('-')
  const parse = (str) => {
    const [mm = '0', ss = '0'] = String(str).split(':')
    const m = Number(mm)
    const s = Number(ss)
    if (!Number.isFinite(m) || !Number.isFinite(s)) return null
    return m * 60 + s
  }
  const start = parse(startStr)
  const end = parse(endStr)
  if (start == null || end == null) return null
  return { start, end }
}

// 将秒格式化为 "mm:ss"
export function formatMMSS(seconds) {
  const sec = Math.max(0, Math.floor(Number(seconds) || 0))
  const mm = String(Math.floor(sec / 60)).padStart(2, '0')
  const ss = String(sec % 60).padStart(2, '0')
  return `${mm}:${ss}`
}

/**
 * @description:  基于上一行的区间生成下一段区间（默认 +5 秒）
 * @param {*} lastRange
 * @param {*} addSec
 * @return {*}
 */
export function getNextRange(lastRange, addSec = 5) {
  const parsed = parseTimeRange(lastRange)
  if (!parsed) {
    return '00:00-00:05'
  }
  const start = parsed.end
  const end = parsed.end + addSec
  return `${formatMMSS(start)}-${formatMMSS(end)}`
}

export function getDuration(list) {
  return list.reduce((acc, cur) => {
    const parsed = parseTimeRange(cur.time_range)
    if (parsed) {
      return acc + (parsed.end - parsed.start)
    }
    return acc
  }, 0)
}

export function getKeywordList(str) {
  let keyElements = []
  const keywords = str.replace('，', ',')
  keyElements = keywords.split(',')

  return keyElements.filter((word) => !!word.trim())
}

export function getRowEditStatus() {
  return {
    titleEdit: false,
    descEdit: false,
    dialogueEdit: false,
    focusEdit: false,
    emoEdit: false,
    keywordsEdit: false,
    shotRematchLoading: false,
    shotOptimizeLoading: false
  }
}
